<template>
    <div class="error-page">
        <div class="container">
            Сообщить об ошибке
        </div>
    </div>
</template>

<script>
    export default {
        name: 'error--page',
        components: {
        },
        data () {
            return {
                title: 'Сообщить об ошибке',
            }
        },
        methods: {
        },
        beforeCreate() {
            document.body.dataset.page = 'error';
        },
        created () {
            document.title = this.title;
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/error-page/error-page.scss';
    // @import '@/styles/respond/404/404-page-respond.scss';
</style>